import React from "react"
import { faUserFriends } from "@fortawesome/free-solid-svg-icons"

import CardItem from "../components/CardItem"


const JobItem = (props) => 
    <CardItem icon={faUserFriends} {...props} />

export default JobItem